import { Box, Typography } from '@mui/material';
import { totalCountColumns } from '../table/DashboardData';
import { Tables } from '@/component/pools/table/Tables';
import { ResReadDashboardType } from '@/types';
import { packBigNumbers } from '@/lib/BigNumbers';
import BigNumber from 'bignumber.js';

export default function TotalCount({ datas }: { datas: ResReadDashboardType[] }) {
  // datas는 이미 배열이므로 직접 사용
  let total = BigNumber(0);
  const list: ResReadDashboardType[] = datas.map((data) => {
    total = total.plus(data.value.toString());
    return {
      name: data.name,
      value: packBigNumbers(data.value),
    };
  });
  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        총 참여 횟수 {packBigNumbers(total.toString())}
      </Typography>
      <Box sx={{ width: '100%' }}>{list && <Tables list={list} columns={totalCountColumns} getRowId={(row) => row.name} />}</Box>
    </Box>
  );
}
